import { Button, Card, CardContent, List, ListItem, ListItemIcon, ListItemText, makeStyles } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import { CardHeader } from "@material-ui/core";
import { parseAddressTypeToIcons } from 'util/parseAddressIcons';
import { Add } from '@material-ui/icons';
import { useTrackEvent } from 'util/trackEvent';

const useStyles = makeStyles(theme => ({
}));
const ExistingLocationList = ({
  onConfirmLocation = (loc) => { },
  locations = [],
  onSwitchToAddMode = () => { },
  onCtaRef=()=>{}
}) => {
  const classes = useStyles()
  const trackEvent = useTrackEvent()

  useEffect(
    () => {
      onCtaRef(null)
    }, []
  );
  return (
    <Card
    >
      <CardContent>
        <List
          style={{
            
            overflowY: 'auto'
          }}
        >
          {locations?.sort((a, b) => b.id - a.id)?.map((loc, index) => {
            return (
              <ListItem
                button
                key={index}
                onClick={() => {
                  trackEvent('Create Booking Location Form - Select Existing Location')
                  onConfirmLocation(loc)
                }}
                divider
              >
                <ListItemIcon >{parseAddressTypeToIcons(loc?.type_name)}</ListItemIcon>
                <ListItemText
                  primary={`${[loc.number, loc.street_name, ',', loc?.city?.name, loc?.area?.name].filter(Boolean).join(' ')}`}
                  secondary={
                    <div style={{ flexDirection: 'column', display: 'flex' }}>
                      <span>{loc?.address}</span>
                      <span>{loc?.notes}</span>
                    </div>
                  }
                />
              </ListItem>
            )
          }
          )}
        </List>
      </CardContent>
    </Card>
  )
}

export { ExistingLocationList }